import { useNavigate } from '@tanstack/react-router';
import type { LabelSelection } from '../features/labels/labels.ts';
import { MAX_LABEL_PRODUCTS } from '../features/labels/labels.ts';
import { LABELS_DEFAULTS } from './search-params.ts';

export const useOpenLabels = () => {
  const navigate = useNavigate();
  return ({ productIds, focus }: LabelSelection) => {
    void navigate({
      to: '/products/labels',
      search: {
        ...LABELS_DEFAULTS,
        product: productIds.slice(0, MAX_LABEL_PRODUCTS),
        variant: focus?.variantId ?? null,
        quantity: focus?.quantity ?? null,
      },
    });
  };
};
